import React, { PropTypes } from 'react'

function ProductSpecs({ data }) {
	const rows = Object.keys(data.Specifications).map((label) => {
		const value = data.Specifications[label]
		return (
			<tr key={label}>
				<td width="40%">{label}</td>
				<td dangerouslySetInnerHTML={{__html: value }} />
			</tr>
		)
	})
	return (
		<table>
			<caption>Specifications</caption>
			<tbody>
				{rows}
			</tbody>
		</table>
	)
}

ProductSpecs.propTypes = {
	data: PropTypes.object.isRequired
}

ProductSpecs.defaultProps = {

}

export default ProductSpecs



// WEBPACK FOOTER //
// ../components/Product/ProductSpecs.js